// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SQig","title":"styles_title__1uyE1"};